import { createClient } from '@supabase/supabase-js';

// ============================================================
// 🌊 WAVES UPON WAVES - SUPABASE CONFIG
// ============================================================
// Replace these with your Supabase project credentials.
// You'll find them at: https://supabase.com/dashboard → Your Project → Settings → API
//
// SUPABASE_URL looks like: https://abcdefghijk.supabase.co
// SUPABASE_ANON_KEY looks like: eyJhbGciOiJIUzI1NiIs... (a long string)
// ============================================================

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// If no Supabase credentials are set, the app runs in demo mode
// (everything works but nothing saves between page refreshes)
export const supabase = SUPABASE_URL && SUPABASE_ANON_KEY
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
  : null;
